
export const USER_ADMIN_CONTACT_MARKERS = {
  contacts: '=== ANSPRECHPARTNER ===',
  billing: '=== RECHNUNGSLEGUNG ===',
  billingAddress: 'Postanschrift:',
  billingEmail: 'E-Mail Rechnungslegung:',
} as const;

export const USER_ADMIN_REGION_MARKERS = {
  locations: 'Einsatzort(e):',
  localFeatures: 'Lokale Besonderheiten im Winter:',
  elevationMin: '   - Tiefste Lage:',
  elevationMax: '   - Höchste Lage:',
  elevationUnit: ' m über NN',
  bridges: 'Brücken im Einsatzgebiet:',
  gmaPlants: '=== GMA ANLAGEN ===',
  gmaExists: 'GMA Vorhanden:',
  gmaDetails: '=== GMA DETAILS ===',
  gmaCoordinates: 'Geokoordinaten & Höhe:',
  gmaManufacturer: 'Hersteller & Typ:',
  gmaWebcam: 'Webcam:',
  productKeySeparator: ' | Produkt-Key: ',
} as const;

export const USER_ADMIN_GMA = {
  campbellWinterSenseSolar: 'Campbell; Modell: Wintersense Solar',
  webcamAvailableText: 'Webcam vorhanden',
  defaultWebcamValue: 'keine',
  availableWebcamValue: 'vorhanden',
} as const;

export type UserAdminGmaWebcamValue =
  | typeof USER_ADMIN_GMA.defaultWebcamValue
  | typeof USER_ADMIN_GMA.availableWebcamValue;

export type UserAdminYesNoValue =
  | typeof USER_ADMIN_FORM_VALUES.yes
  | typeof USER_ADMIN_FORM_VALUES.no;

export const USER_ADMIN_FORM_VALUES = {
  yes: 'ja',
  no: 'nein',
  yesUppercase: 'JA',
  many: 'viele',
  few: 'wenige',
  none: 'keine',
  emptyPlaceholder: '-',
} as const;

export const USER_ADMIN_BRIDGE_VALUES = [
  USER_ADMIN_FORM_VALUES.many,
  USER_ADMIN_FORM_VALUES.few,
  USER_ADMIN_FORM_VALUES.none,
] as const;
